import React from "react";
import cn from "classnames";

import styles from "../../assets/css/main.module.css";

class Alert extends React.Component {
  state = {
    shwoingMessage: this.props.showMessage,
    messageToShow: this.props.alertMessage.toString()
  };

  UNSAFE_componentWillReceiveProps = newProps => {
    if (newProps.showMessage !== this.state.shwoingMessage)
      this.setState({
        shwoingMessage: newProps.showMessage,
        messageToShow: newProps.alertMessage
      });
  };

  toggleShowingMessage = () => {
    if (this.props.push) this.props.push(this.props.link);
    this.props.close();
    this.setState({
      shwoingMessage: !this.state.shwoingMessage
    });
  };

  childClick = e => {
    this.props.close();

    e.stopPropagation();
  };

  render = () => {
    return (
      <React.Fragment>
        <div
          className={
            this.state.shwoingMessage
              ? cn(styles["modal-layover"])
              : cn(styles["modal-layover-hidden"])
          }
          onClick={this.toggleShowingMessage}
        >
          <div
            className={
              this.state.shwoingMessage
                ? cn(styles["modal-content"])
                : cn(styles["hide"])
            }
            onClick={this.childClick}
          >
            <table
              className={cn(styles["table-of-tables"])}
              onClick={this.childClick}
            >
              <thead>
                <tr>
                  <th scope="col">Message</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.state.messageToShow}</td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr"
              }}
            >
              <div></div>
              <div></div>
              <div>
                <button
                  className={cn(styles["delete-table"])}
                  style={{ marginTop: "40px", fontWeight: "bold" }}
                  onClick={this.toggleShowingMessage}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}
export default Alert;
